// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { FaArrowRight } from "react-icons/fa6";
// import { FaUserPen } from "react-icons/fa6";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import UserHeader from "../../components/common/UserHeader";
// import banner from "../../assets/headerBanner.png";
// import Loader from "../../components/common/Loader";

// const ArticlesPage = () => {
//   const navigate = useNavigate();
//   const [articles, setArticles] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });
//     fetchArticles();
//   }, []);

//   const fetchArticles = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/articles/get-all-articles`
//       );
//       const data = Array.isArray(res.data)
//         ? res.data
//         : res.data.articles || res.data.data || [];
//       setArticles(data);
//       setError(null);
//     } catch (err) {
//       console.error("Failed to fetch articles:", err);
//       setError("Unable to load articles. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getImageUrl = (article) =>
//     article?.images?.[0] && article.images[0].trim() !== ""
//       ? article.images[0]
//       : `https://via.placeholder.com/600x400/2F9BD6/FFFFFF?text=${encodeURIComponent(
//           article?.title || "Article"
//         )}`;

//   return (
//     <>
//       {/* Page Banner Header */}
//       <UserHeader headerImg={banner} pageName="Our Articles" mainText="Home" />

//       {/* ── Loading ── */}
//       {loading && (
//         <div className="py-10 px-4 md:px-10">
//           <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4">
//             <Loader />
//             <span className="ml-2">Please Wait...</span>
//           </div>
//         </div>
//       )}

//       {/* ── Error ── */}
//       {!loading && error && (
//         <div className="py-10 px-4 md:px-10">
//           <div className="rounded-md flex flex-col gap-3 tracking-wider font-semibold justify-center items-center border border-red-400 p-6 text-red-600">
//             <p>{error}</p>
//             <button
//               onClick={fetchArticles}
//               className="text-sm border border-red-500 px-5 py-2 rounded hover:bg-red-500 hover:text-white transition-colors duration-200"
//             >
//               Retry
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ── Empty ── */}
//       {!loading && !error && articles.length === 0 && (
//         <div className="py-10 px-4 md:px-10">
//           <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4">
//             No articles available at the moment.
//           </div>
//         </div>
//       )}

//       {/* ── Section + Cards ── */}
//       {!loading && !error && articles.length > 0 && (
//         <div className="py-10 px-4 md:px-10">

//           {/* Section heading */}
//           <div className="flex items-center justify-center flex-col gap-2 mb-10">
//             <span
//               data-aos="fade-down"
//               className="border-b-2 font-semibold border-[#FF3131] py-2 tracking-wide text-center text-[#FF3131]"
//             >
//               OUR ARTICLES
//             </span>
//             <p
//               data-aos="flip-right"
//               className="lg:text-4xl md:text-3xl text-2xl tracking-wider font-bold text-center"
//             >
//               <span className="text-[#2F9BD6]">Latest</span> Article Posts
//             </p>
//             <p className="text-gray-400 text-sm mt-1">
//               {articles.length} article{articles.length !== 1 ? "s" : ""} available
//             </p>
//           </div>

//           {/* 4-column card grid */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 items-start gap-6">
//             {articles.map((article, i) => (
//               <div
//                 key={article._id || i}
//                 onClick={() => navigate(`/article/${article._id}`)}
//                 data-aos={i % 2 === 0 ? "zoom-in-right" : "zoom-out-left"}
//                 className="bg-white shadow-lg rounded-2xl overflow-hidden w-full cursor-pointer hover:shadow-xl transition-all duration-300 group"
//               >
//                 {/* Image area */}
//                 <div className="w-full h-56 bg-gray-200 overflow-hidden relative">
//                   <img
//                     src={getImageUrl(article)}
//                     alt={article?.title || "Article"}
//                     className="w-full h-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-110"
//                   />
//                   {/* Number badge */}
//                   <div className="absolute top-3 left-3 bg-[#2F9BD6] text-white text-xs font-bold px-2.5 py-1 rounded-full tracking-wider shadow">
//                     {String(i + 1).padStart(2, "0")}
//                   </div>
//                 </div>

//                 {/* Card body */}
//                 <div className="p-5 flex flex-col gap-3">
//                   {/* Red accent bar */}
//                   <div className="w-10 h-1 rounded-full bg-[#FF3131]" />

//                   {/* Author */}
//                   {article.author && (
//                     <div className="flex items-center gap-2 text-gray-500 text-sm">
//                       <FaUserPen className="text-[#2F9BD6]" />
//                       <span>{article.author}</span>
//                     </div>
//                   )}

//                   {/* Title */}
//                   <h3 className="text-[17px] font-semibold text-[#1C1C25] leading-snug">
//                     {article?.title || "Untitled Article"}
//                   </h3>

//                   {/* Read More CTA */}
//                   <div className="flex items-center gap-2 text-[#2F9BD6] text-sm font-medium mt-auto group-hover:gap-3 transition-all duration-200">
//                     <span>Read More</span>
//                     <FaArrowRight className="text-xs transition-transform duration-200 group-hover:translate-x-1" />
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ArticlesPage;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa6";
import { FaUserPen } from "react-icons/fa6";
import AOS from "aos";
import "aos/dist/aos.css";
import UserHeader from "../../components/common/UserHeader";
import banner from "../../assets/headerBanner.png";
import Loader from "../../components/common/Loader";
import SEO from "../../components/common/SEO"; 

const ArticlesPage = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/articles/get-all-articles`
      );
      const data = Array.isArray(res.data)
        ? res.data
        : res.data.articles || res.data.data || [];
      setArticles(data);
      setError(null);
    } catch (err) {
      console.error("Failed to fetch articles:", err);
      setError("Unable to load articles. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (article) =>
    article?.images?.[0] && article.images[0].trim() !== ""
      ? article.images[0]
      : `https://via.placeholder.com/600x400/2F9BD6/FFFFFF?text=${encodeURIComponent(
          article?.title || "Article"
        )}`;

  const handleArticleClick = (article) => {
    navigate(`/article/${article.slug || article._id}`);
  };

  return (
    <>
      {/* SEO for Articles Page */}
      <SEO 
        title="Expert Business Articles"
        description="Read insightful articles on company registration, GST, taxation, and professional business solutions in India."
        keywords="business articles, GST articles, company registration guide, BBSR Services"
        canonical="https://www.bbsrservices.co.in/all-article"
        type="website"
      />

      <UserHeader headerImg={banner} pageName="Our Articles" mainText="Home" />

      {/* Rest of your component */}
      {loading && (
        <div className="py-10 px-4 md:px-10">
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4">
            <Loader />
            <span className="ml-2">Please Wait...</span>
          </div>
        </div>
      )}

      {!loading && error && (
        <div className="py-10 px-4 md:px-10">
          <div className="rounded-md flex flex-col gap-3 tracking-wider font-semibold justify-center items-center border border-red-400 p-6 text-red-600">
            <p>{error}</p>
            <button
              onClick={fetchArticles}
              className="text-sm border border-red-500 px-5 py-2 rounded hover:bg-red-500 hover:text-white transition-colors duration-200"
            >
              Retry
            </button>
          </div>
        </div>
      )}

      {!loading && !error && articles.length === 0 && (
        <div className="py-10 px-4 md:px-10">
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4">
            No articles available at the moment.
          </div>
        </div>
      )}

      {!loading && !error && articles.length > 0 && (
        <div className="py-10 px-4 md:px-10">
          <div className="flex items-center justify-center flex-col gap-2 mb-10">
            <span
              data-aos="fade-down"
              className="border-b-2 font-semibold border-[#FF3131] py-2 tracking-wide text-center text-[#FF3131]"
            >
              OUR ARTICLES
            </span>
            <p
              data-aos="flip-right"
              className="lg:text-4xl md:text-3xl text-2xl tracking-wider font-bold text-center"
            >
              <span className="text-[#2F9BD6]">Latest</span> Article Posts
            </p>
            <p className="text-gray-400 text-sm mt-1">
              {articles.length} article{articles.length !== 1 ? "s" : ""} available
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 items-start gap-6">
            {articles.map((article, i) => (
              <div
                key={article._id || i}
                onClick={() => handleArticleClick(article)}
                data-aos={i % 2 === 0 ? "zoom-in-right" : "zoom-out-left"}
                className="bg-white shadow-lg rounded-2xl overflow-hidden w-full cursor-pointer hover:shadow-xl transition-all duration-300 group"
              >
                <div className="w-full h-56 bg-gray-200 overflow-hidden relative">
                  <img
                    src={getImageUrl(article)}
                    alt={article?.title || "Article"}
                    className="w-full h-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-110"
                  />
                  <div className="absolute top-3 left-3 bg-[#2F9BD6] text-white text-xs font-bold px-2.5 py-1 rounded-full tracking-wider shadow">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                </div>

                <div className="p-5 flex flex-col gap-3">
                  <div className="w-10 h-1 rounded-full bg-[#FF3131]" />
                  {article.author && (
                    <div className="flex items-center gap-2 text-gray-500 text-sm">
                      <FaUserPen className="text-[#2F9BD6]" />
                      <span>{article.author}</span>
                    </div>
                  )}
                  <h3 className="text-[17px] font-semibold text-[#1C1C25] leading-snug">
                    {article?.title || "Untitled Article"}
                  </h3>
                  <div className="flex items-center gap-2 text-[#2F9BD6] text-sm font-medium mt-auto group-hover:gap-3 transition-all duration-200">
                    <span>Read More</span>
                    <FaArrowRight className="text-xs transition-transform duration-200 group-hover:translate-x-1" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ArticlesPage;